var _desc, _defs, _rect, _text, _text2, _g, _g2, _g3, _g4, _g5, _g6, _text3, _text4, _g7, _text5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagramForecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 640",
    width: 880,
    height: 640,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "The shit forecast") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Weather-map joke plotting four kinds of backlash by how likely they are and how much they cost: shouting is likely and costs an afternoon, being told you can&#x27;t is near certain and costs weeks, gossip is fairly likely and slowly costs reputation, and removal from the project is rare but costs the whole engagement.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-10%",
    y: "-10%",
    width: "130%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2,
    stdDeviation: 1.6,
    floodColor: "#0b0b0b",
    floodOpacity: 0.18
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,5 L0,10 z",
    fill: "#52514e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 640,
    fill: "#fcfcfb"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 38,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "The shit forecast")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 62,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, "What rains down when something moves, by how likely it is and what it costs.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plot"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 120,
    width: 530,
    height: 440,
    fill: "#f6f5f1",
    stroke: "#e1e0d9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 120,
    width: 238,
    height: 145,
    fill: "#fde3d6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 393,
    width: 238,
    height: 167,
    fill: "#dceafb",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.5,
    y1: 120,
    x2: 242.5,
    y2: 560,
    stroke: "#e1e0d9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 230,
    x2: 640,
    y2: 230,
    stroke: "#e1e0d9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375,
    y1: 120,
    x2: 375,
    y2: 560,
    stroke: "#e1e0d9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 340,
    x2: 640,
    y2: 340,
    stroke: "#e1e0d9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 507.5,
    y1: 120,
    x2: 507.5,
    y2: 560,
    stroke: "#e1e0d9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 450,
    x2: 640,
    y2: 450,
    stroke: "#e1e0d9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "axes"
  }, /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 594,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 600,
    fill: "#52514e",
    textAnchor: "middle"
  }, "How likely it is"), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 578,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#898781",
    textAnchor: "start"
  }, "Rare"), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 578,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#898781",
    textAnchor: "end"
  }, "Certain"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(58 340.0) rotate(-90)",
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 600,
    fill: "#52514e",
    textAnchor: "middle"
  }, "How much it costs you"), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 556,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#898781",
    textAnchor: "end"
  }, "An afternoon"), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 134,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#898781",
    textAnchor: "end"
  }, "The whole"), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 150,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#898781",
    textAnchor: "end"
  }, "project"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "shouting"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#d6d5cd",
    stroke: "#52514e",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 420.6,
    cy: 478.8,
    rx: 18,
    ry: 13
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 440.6,
    cy: 466.8,
    rx: 20,
    ry: 17
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 460.6,
    cy: 478.8,
    rx: 17,
    ry: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.6,
    y: 476.8,
    width: 70,
    height: 15,
    rx: 7,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "436.6,490.8 426.6,510.8 436.6,510.8 430.6,528.8 448.6,502.8 438.6,502.8 444.6,490.8",
    fill: "#eb6834",
    stroke: "#0b0b0b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 484.6,
    y: 474.8,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Shouting"), /*#__PURE__*/React.createElement("text", {
    x: 484.6,
    y: 492.8,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, "Thunderstorms, brief"), /*#__PURE__*/React.createElement("text", {
    x: 484.6,
    y: 508.8,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, "but loud"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "you-cant"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#d6d5cd",
    stroke: "#52514e",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 549.5999999999999,
    cy: 362,
    rx: 16.2,
    ry: 11.700000000000001
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 567.5999999999999,
    cy: 351.2,
    rx: 18,
    ry: 15.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 585.5999999999999,
    cy: 362,
    rx: 15.3,
    ry: 11.700000000000001
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.1999999999999,
    y: 360.2,
    width: 63,
    height: 13.5,
    rx: 6.3,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 541.8,
    y1: 380.4,
    x2: 535.8,
    y2: 398.4,
    stroke: "#2a78d6",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeDasharray: "5 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 553.8,
    y1: 380.4,
    x2: 547.8,
    y2: 398.4,
    stroke: "#2a78d6",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeDasharray: "5 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 565.8,
    y1: 380.4,
    x2: 559.8,
    y2: 398.4,
    stroke: "#2a78d6",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeDasharray: "5 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 577.8,
    y1: 380.4,
    x2: 571.8,
    y2: 398.4,
    stroke: "#2a78d6",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeDasharray: "5 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.8,
    y1: 380.4,
    x2: 583.8,
    y2: 398.4,
    stroke: "#2a78d6",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeDasharray: "5 4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 565.8,
    y: 422.4,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "\u201CYou can\u2019t\u201D"), /*#__PURE__*/React.createElement("text", {
    x: 565.8,
    y: 438.4,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "middle"
  }, "Persistent drizzle"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "gossip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.5,313.59999999999997 q 12,-7 24,0 t 24,0 t 24,0 t 24,0",
    fill: "none",
    stroke: "#52514e",
    strokeWidth: 2,
    strokeDasharray: "2 5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,324.59999999999997 q 12,-7 24,0 t 24,0 t 24,0 t 24,0",
    fill: "none",
    stroke: "#52514e",
    strokeWidth: 2,
    strokeDasharray: "2 5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.5,335.59999999999997 q 12,-7 24,0 t 24,0 t 24,0 t 24,0",
    fill: "none",
    stroke: "#52514e",
    strokeWidth: 2,
    strokeDasharray: "2 5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,346.59999999999997 q 12,-7 24,0 t 24,0 t 24,0 t 24,0",
    fill: "none",
    stroke: "#52514e",
    strokeWidth: 2,
    strokeDasharray: "2 5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 349.5,
    y: 297.6,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Gossip"), /*#__PURE__*/React.createElement("text", {
    x: 349.5,
    y: 373.6,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, "Fog rolling in. Meeting"), /*#__PURE__*/React.createElement("text", {
    x: 349.5,
    y: 389.6,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, "invites quietly vanish"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "removal"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.8,
    cy: 155.60000000000002,
    rx: 30,
    ry: 4.5,
    fill: "none",
    stroke: "#0b0b0b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.3,
    cy: 166.60000000000002,
    rx: 25,
    ry: 4.5,
    fill: "none",
    stroke: "#0b0b0b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 199.8,
    cy: 177.60000000000002,
    rx: 20,
    ry: 4.5,
    fill: "none",
    stroke: "#0b0b0b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.3,
    cy: 188.60000000000002,
    rx: 15,
    ry: 4.5,
    fill: "none",
    stroke: "#0b0b0b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.8,
    cy: 199.60000000000002,
    rx: 10,
    ry: 4.5,
    fill: "none",
    stroke: "#0b0b0b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.3,
    cy: 210.60000000000002,
    rx: 5,
    ry: 4.5,
    fill: "none",
    stroke: "#0b0b0b",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 238.8,
    y: 159.6,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Removed from"), /*#__PURE__*/React.createElement("text", {
    x: 238.8,
    y: 177.6,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "the project"), /*#__PURE__*/React.createElement("text", {
    x: 238.8,
    y: 195.6,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, "Rare. Arrives by phone,"), /*#__PURE__*/React.createElement("text", {
    x: 238.8,
    y: 211.6,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, "usually on a Friday"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 255.2,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Get a sledgehammer and an umbrella first")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 548,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "end"
  }, "Just weather. Warn the team.")), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "outlook"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 668,
    y: 120,
    width: 188,
    height: 300,
    rx: 4,
    fill: "#fff",
    stroke: "#e1e0d9"
  }), /*#__PURE__*/React.createElement("text", {
    x: 682,
    y: 148,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#52514e",
    textAnchor: "start",
    letterSpacing: 1.2
  }, "THE OUTLOOK"), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Marker Felt, Chalkboard SE, Bradley Hand, Comic Sans MS, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 682,
    y: 176
  }, "Unsettled, with"), /*#__PURE__*/React.createElement("tspan", {
    x: 682,
    y: 193.5
  }, "HiPPOs moving in"), /*#__PURE__*/React.createElement("tspan", {
    x: 682,
    y: 211
  }, "from the east.")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Marker Felt, Chalkboard SE, Bradley Hand, Comic Sans MS, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 682,
    y: 248
  }, "Change board:"), /*#__PURE__*/React.createElement("tspan", {
    x: 682,
    y: 265.5
  }, "drizzle until the"), /*#__PURE__*/React.createElement("tspan", {
    x: 682,
    y: 283
  }, "2nd Thursday.")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Marker Felt, Chalkboard SE, Bradley Hand, Comic Sans MS, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 682,
    y: 320
  }, "Silence is not"), /*#__PURE__*/React.createElement("tspan", {
    x: 682,
    y: 337.5
  }, "sunshine. Check"), /*#__PURE__*/React.createElement("tspan", {
    x: 682,
    y: 355
  }, "that anything"), /*#__PURE__*/React.createElement("tspan", {
    x: 682,
    y: 372.5
  }, "actually moved.")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 668,
    y: 460
  }, "Price each one before"), /*#__PURE__*/React.createElement("tspan", {
    x: 668,
    y: 476.2
  }, "you swing. See"), /*#__PURE__*/React.createElement("tspan", {
    x: 668,
    y: 492.5
  }, "lessons 3 and 4."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramForecast);
export default __webpack_public_path__ + "static/media/diagram-forecast.26c4417cbab826897b0d6f3569cd2d63.svg";
export { ForwardRef as ReactComponent };